import Backbone from 'backbone';
import State from './State';

export default Backbone.Collection.extend({
  model: State,
  resetToDefault() {
    this.each(function(model) {
      if (model.get('isActive')) {
        model.stopRecordingState();
      }
      model.set('isActive', false, { silent: 1 });
    });
  }
});
